export default __webpack_public_path__ + "static/logo-black-983ee1812426de26e671be9ee29a3bff.svg";